module.exports = __webpack_public_path__ + "static/media/ball.bb2b608d.svg";